// on client

import * as React from 'react';
import { hydrate, render as reactRender } from 'react-dom';
import { setLocale } from '../i18n';

export const render = (id, Component) => {
  if (typeof document !== 'undefined') {
    const root = document.getElementById(id);
    if (root) {
      const docEl = document.documentElement;

      if (docEl) {
        setLocale(docEl.lang);
      }

      // Use hydrate only if root has server-rendered content
      // Otherwise use render (e.g., in dev environment without SSR)
      const hasServerRenderedContent = root.hasChildNodes();

      if (hasServerRenderedContent) {
        hydrate(<Component />, root);
      } else {
        reactRender(<Component />, root);
      }
    }
  }
};
